// Full-screen boot splash shown by the Suspense fallback in AppShell while
// the first lazy route chunk is loading. Matches the black background used
// throughout the mobile shell so there is no flash of unstyled content.
import { useEffect } from "react";

const BOOT_SCROLL_Y_KEY = "quartel.bootScrollY";

/**
 * Full-viewport loading splash for the initial app boot.
 * Swap for an animated branding frame once assets are finalized in Phase 2.
 *
 * @example
 * <Suspense fallback={<SplashLoader />}>…</Suspense>
 */
export function SplashLoader(): React.JSX.Element {
  useEffect(() => {
    const recordScrollY = (): void => {
      if (window.scrollY > 0) {
        window.sessionStorage.setItem(
          BOOT_SCROLL_Y_KEY,
          String(window.scrollY),
        );
        return;
      }
      window.sessionStorage.removeItem(BOOT_SCROLL_Y_KEY);
    };
    recordScrollY();
    window.addEventListener("scroll", recordScrollY, { passive: true });
    return () => window.removeEventListener("scroll", recordScrollY);
  }, []);
  // Intentionally empty: the spinning ring + "Carregando" label were removed
  // per operator request (ugly page-level spinner). The container keeps the
  // full-viewport background (no FOUC), the scroll-height reserve and the
  // a11y status role.
  return (
    <div
      data-testid="splash-loader"
      className="absolute inset-x-0 top-0 z-50 flex min-h-dvh flex-col items-center justify-center bg-background md:min-h-[1500px]"
      role="status"
      aria-label="Carregando"
    />
  );
}
